import Application from './application'
import GlobeScene from './scene'
import Marker from './marker'

export default function globeVisualization(canvas){
    const scene = new GlobeScene();
    const instance = new Application(canvas,[scene]);

    return {
        get canvas(){
            return canvas;
        },
        set markers(markers){
            scene.globe.markers = markers.map(
                options => (
                    new Marker(options)
                )
            )
        },
        set offset(num){
            scene.offset = num;
        },
        set selectedIndex(index){
            scene.globe.selectedIndex = index;
        },
        destroy(){
            instance.destroy();
        }
    }
}